var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.colors.length > 1
    ? _c("div", { staticClass: "color-index align-self-center" }, [
        _c("div", { staticClass: "ob1-color-chips ob1-color-chips-mini" }, [
          _c("span", { staticClass: "visually-hidden" }, [
            _vm._v("Groupe de couleurs disponibles non sélectionnables"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex flex-column" },
            [
              _vm._l(_vm.allColors(), function (color, index) {
                return [
                  _c(
                    "div",
                    {
                      key: color.code + "-" + index,
                      staticClass: "ob1-color-chip",
                      style: "background-color: " + color.code + ";",
                    },
                    [
                      _c("span", {
                        staticClass: "ob1-color-chips-mini-tooltip",
                        domProps: { innerHTML: _vm._s(color.colorName) },
                      }),
                    ]
                  ),
                ]
              }),
            ],
            2
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }